import ENV from "../env";
import redirectToTopLevel from "./redirectToTopLevel";

const request = async (path, payload) => {
  const response = await fetch(`${ENV.firebaseApiUrl}/stripe/${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || "Partner checkout failed");
  return data;
};
export const createPartnerCheckout = async (payload) => {
  const data = await request("create-partner-checkout-session", payload);
  try {
    sessionStorage.setItem(`partner-checkout:${payload.eventId}:${payload.partnerId}`, JSON.stringify({ orderId: data.orderId, token: payload.requestId }));
  } catch (_) { /* Storage may be unavailable in embedded/private browsers. */ }
  redirectToTopLevel(data.url);
};
export const getPartnerOrder = (payload) => request("partner-order/status", payload);
export const getPartnerTickets = (payload) => request("partner-tickets", payload);
export const resumePartnerCheckout = async ({ eventId, partnerId }) => {
  const key = `partner-checkout:${eventId}:${partnerId}`;
  let saved;
  try { saved = JSON.parse(sessionStorage.getItem(key) || "null"); } catch (_) { return null; }
  if (!saved?.orderId || !saved?.token) return null;
  const order = await getPartnerOrder({ eventId, ...saved, cancel: true });
  if (["paid", "failed", "expired", "refunded", "refund_failed"].includes(order.status)) {
    try { sessionStorage.removeItem(key); } catch (_) { /* Optional storage. */ }
  }
  return order;
};
